import { SidebarContent } from './SidebarContent.js';

export function Sidebar(): React.ReactElement {
  return (
    <aside className="w-60 shrink-0 border-r border-edge bg-surface flex flex-col">
      <SidebarContent />
    </aside>
  );
}
